import * as actionTypes from "../../actions/actionTypes";
const login = (state = { email: "", password: "" }, action) => {
  switch (action.type) {
    case actionTypes.SET_LOGIN_DATA:
      // When user logged in the portal then set auto skip tour key to true 
      // To skip the tour step.
      localStorage.setItem("auto_skip_tour", true);
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default login;
